import { render } from "./account-check-detail.vue?vue&type=template&id=da9bd74e&scoped=true&ts=true"
import script from "./account-check-detail.vue?vue&type=script&lang=ts"
export * from "./account-check-detail.vue?vue&type=script&lang=ts"

import "./account-check-detail.vue?vue&type=style&index=0&id=da9bd74e&scoped=true&lang=stylus"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_8f6e2ea806ee27baec234857288b09f4\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da9bd74e"]])

export default __exports__